import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyDDOArWGFUvOe7F5ptiMm1agMOWT7oOuxA",
    authDomain: "my-chat-room-apps.firebaseapp.com",
    databaseURL: "https://my-chat-room-apps.firebaseio.com",
    projectId: "my-chat-room-apps",
    storageBucket: "my-chat-room-apps.appspot.com",
    messagingSenderId: "447233164605",
    appId: "1:447233164605:web:e5061d477951cff62c3154",
    measurementId: "G-T3QM7ZLLK5"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;